export const FooterText = `&copy; 2017-${new Date().getFullYear()}`;
